module.exports = __webpack_public_path__ + "img/yinglou.ac40768d.jpg";